import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PopularCourseCareerService} from '../../../shared/services/popular-course-career.service';

interface CareerTableRow {
    jobTitle: string;
    salaryRange: string;
}

import {UtilsService} from '../../../shared/services/utils.service';
import {environment} from '../../../../environments/environment';
@Component({
    selector: 'app-popular-course-career',
    templateUrl: './popular-course-career.component.html',
    styleUrls: ['./popular-course-career.component.scss']
})
export class PopularCourseCareerComponent implements OnInit {
    public popularCourseId: any;
    submitting: any = false;
    dataExists: any = false;
    // Superseded by the rich table editor below (table_html) — kept commented out for now
    // in case the structured Job Title/Salary table needs to come back.
    // tableRows: CareerTableRow[] = [];
    editorBlocks: Array<{type: 'content' | 'table', value: string}> = [{type: 'content', value: ''}];
    tinymceApiKey = environment.tinymceApiKey;

    tableEditorInit = {
        menubar: false,
        branding: false,
        plugins: 'lists link autolink charmap media searchreplace visualblocks wordcount codesample table',
        toolbar: 'undo redo | bold italic underline | bullist numlist | link media charmap | ' +
            'table tableinsertrowbefore tableinsertrowafter tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol | removeformat'
    };

    constructor(private activatedRoute: ActivatedRoute,
                private popularCourseCareerService: PopularCourseCareerService) {
    }

    ngOnInit(): void {
        this.popularCourseId = this.activatedRoute.snapshot.parent.params['id'];
        this.refresh();
    }

    refresh() {
        this.popularCourseCareerService.detailByAdmin(this.popularCourseId).subscribe(data => {
            this.dataExists = !!(data && data['info']);

            const blocks = (data && data['info']) ? UtilsService.splitEditorBlocks(data['info']) : [];
            if (data && data['table_html']) {
                blocks.push({type: 'table', value: data['table_html']});
            }
            this.editorBlocks = blocks.length ? blocks : [{type: 'content', value: ''}];

            // this.tableRows = (data && data['table_data'] && data['table_data'].length) ? data['table_data'] : [];
            // if (this.tableRows.length === 0) {
            //     this.addRow();
            // }
        });
    }

    addEditorBlock(editor: 'content' | 'table') {
        this.editorBlocks.push({type: editor, value: ''});
    }

    removeEditorBlock(index: number) {
        this.editorBlocks.splice(index, 1);
    }

    // addRow() {
    //     this.tableRows.push({jobTitle: '', salaryRange: ''});
    // }
    //
    // removeRow(index: number) {
    //     this.tableRows.splice(index, 1);
    // }

    submit() {
        const info = UtilsService.joinEditorBlocks(this.editorBlocks);

        const params = {
            'info': info ? UtilsService.encodeHtml(info) : '',
            'table_html': ''
            // 'table_data': cleanedRows — commented out along with the structured table UI above
        };
        this.submitting = true;
        if (this.dataExists) {
            this.popularCourseCareerService.updateByAdmin(this.popularCourseId, params).subscribe(data => {
                this.submitting = false;
            }, error => {
                this.submitting = false;
            });
        } else {
            this.popularCourseCareerService.createByAdmin(this.popularCourseId, params).subscribe(data => {
                this.submitting = false;
                this.dataExists = true;
            }, error => {
                this.submitting = false;
            });
        }
    }
}
